module.exports = __webpack_public_path__ + "img/final.1f0021a4.png";